import clsx from 'clsx';
import React, {
    Fragment, useEffect, useState, useCallback,
} from 'react';
import $ from 'jquery';
import { useNavigate } from '@reach/router';
import moment from 'moment';
import parse from 'html-react-parser';
import { SuggestionsContext } from '../../context/SuggestionsContext';
import PageUpdateSuggestionModal from './PageUpdateSuggestionModal';
import useUsers from '../../hooks/useUsers';
import { getSuggestionUrl, getUserUrl } from '../../utilities/urlHelper';
import { scrollToSuggestion } from '../../utilities/scrollUtilities';
import { canEditSuggestion } from '../../utilities/permissionsUtilities';
import { sanitizeHTML } from '../../utilities/sanitizeHTML';

const EditUpdateSuggestionItem = ({ suggestion }) => {
    const [showPageUpdateSuggestionModal, setShowPageUpdateSuggestionModal] = useState(false);
    const canEdit = canEditSuggestion() || window.userId === suggestion.requester.id;

    return (
        <Fragment>
            { canEdit
            && <span className="comment-action-button right" onClick={() => setShowPageUpdateSuggestionModal(true)}>Edit</span>}
            { canEdit && showPageUpdateSuggestionModal && <PageUpdateSuggestionModal closeModal={() => setShowPageUpdateSuggestionModal(false)} suggestion={suggestion} /> }
        </Fragment>
    );
};

const UpdatePageButton = (props) => {
    const { suggestion } = props;
    const updatePageUrl = `${window.location.pathname}/edit?suggestionId=${suggestion.id}`;

    const navigate = useNavigate();

    const onClick = useCallback((e) => {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        return navigate(`${window.location.pathname}/edit?suggestionId=${suggestion.id}`, { state: { suggestion } });
    }, [suggestion, navigate]);

    const onClickAndHideBanner = useCallback((e) => {
        $(e.target).parent().hide();
        return onClick(e);
    }, []);

    useEffect(() => {
        document.getElementById('page-update-suggestion-button')?.addEventListener('click', onClickAndHideBanner);
        return () => {
            document.getElementById('page-update-suggestion-button')?.removeEventListener('click', onClickAndHideBanner);
        };
    }, []);

    return (
        <a href={updatePageUrl} className="mt2 btn btn-delete btn-small h5" onClick={onClick}>Update page</a>
    );
};

const UpdateSuggestionItem = (props) => {
    const { suggestion, canUpdate } = props;
    const time = moment.utc(suggestion.created_at);
    const assigneeText = suggestion.assignable
        ? ` requested an update from ${suggestion.assignable.display_name}`
        : ' requested an update ';
    const descriptionHtml = sanitizeHTML(suggestion.description.replace(/(?:\r\n|\r|\n)/g, '<br />'));
    const users = useUsers();
    if (!users) return null;
    const activeUserIds = users.filter(user => user.id).map(user => user.id);
    const isDeactivatedRequester = !activeUserIds.includes(suggestion.requester.id);
    const suggesterDisplayName = isDeactivatedRequester ? `${suggestion.requester.display_name} (Deactivated)` : suggestion.requester.display_name;

    return (
        <div className="page-update-suggestion" id={`suggestion-${suggestion.id}`}>
            <div className="flex-none">
                <a href={getUserUrl(suggestion.requester.id)}>
                    <img className={clsx('post-comment-avatar', { 'grayscale-img': isDeactivatedRequester })} src={suggestion.requester.image_192} width="28" height="28" alt="" />
                </a>
            </div>
            <div className="post-comment-content">
                <div className="post-comment-meta">
                    <a href={getUserUrl(suggestion.requester.id)} className="commenter">{suggesterDisplayName}</a>
                    <a href={getSuggestionUrl(suggestion.id)} className="gray">{ assigneeText }</a>
                    <a href={`#suggestion-${suggestion.id}`} title={time.local().toString()} className="post-comment-time gray">{time.fromNow()}</a>
                    <EditUpdateSuggestionItem suggestion={suggestion} />
                </div>
                <div>{parse(descriptionHtml)}</div>
                { canUpdate && <UpdatePageButton suggestion={suggestion} />}
            </div>
        </div>
    );
};

class PageUpdateSuggestions extends React.Component {
    static contextType = SuggestionsContext;

    componentDidMount() {
        this.getPageUpdateSuggestions();
    }

    componentWillUnmount() {
        if (this.activeRequest) {
            this.activeRequest.abort();
        }
    }

    getPageUpdateSuggestions = () => {
        const { suggestions, setSuggestions } = this.context;
        setSuggestions(null);

        if (this.activeRequest) {
            this.activeRequest.abort();
        }

        this.activeRequest = $.get(`/api/teams/${window.teamId}/pages/${this.props.page.id}/suggestions`);

        return this.activeRequest
            .done(({ suggestions }) => {
                if (suggestions) {
                    setSuggestions(suggestions);
                }
            }).catch(console.error)
            .always(() => scrollToSuggestion());
    };

    render() {
        const { suggestions } = this.context;

        if (!suggestions || !suggestions.length) return null;
        return (
            <Fragment>
                {suggestions.map(suggestion => <UpdateSuggestionItem key={suggestion.id} suggestion={suggestion} canUpdate={this.props.page.can_update} />)}
            </Fragment>
        );
    }
}

export default PageUpdateSuggestions;
